import {
    Box,
    Image,
    Heading,
    Text,
    Button,
    Container,
} from "@chakra-ui/react"

import { LuArrowRight } from "react-icons/lu"

export default function HomeBanner() {
    return (
        <Box position="relative" width="100%" height="550px" id="home">
            {/* Background Image */}
            <Image
                src="chroma_banner.png"
                width="100%"
                height="100%"
                objectFit="cover"
                alt="Chroma Detailing Banner"
            />

            {/* Blur/Dark Overlay */}
            <Box
                position="absolute"
                top="0"
                left="0"
                width="100%"
                height="100%"
                bg="rgba(0, 0, 0, 0.4)" // soft dark overlay
                backdropFilter="blur(1px)" // subtle blur
                zIndex="0"
            />

            {/* Overlay Content inside Container */}
            <Box
                position="absolute"
                top="50%"
                left="0"
                width="100%"
                transform="translateY(-50%)"
                zIndex="1"
                color="white"
            >
                <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
                    <Box maxW={{ base: "90%", md: "70%" }}>
                        <Heading fontSize={{ base: "2xl", md: "6xl" }} mb={8} fontWeight="bold">
                            Chroma Detailing
                        </Heading>
                        <Text fontSize={{ base: "md", md: "lg" }} mb={12} fontWeight="medium">
                            Get the best results out of your car from Sydney's most chosen detailer with over 30 years of experience.
                        </Text>
                        <Button bgColor="#FFFFFF" color="#131416" _hover={{ boxShadow: "xl", transform: "scale(1.05)", transition: "0.3s ease-in-out" }} asChild>
                            <a href="#contact">
                            Get Your Consultation <LuArrowRight />
                            </a>
                        </Button>
                    </Box>
                </Container>
            </Box >
        </Box >
    )
}